<template>
    <v-container fluid>
        <v-row align="start" justify="space-between" class="dddark pt-6 rounded" style="margin-top: -10px;">
          <v-col cols="12" sm="12" md="4" class="mr-auto">
          </v-col>
            <v-col cols="auto" v-if="!isMobile" >
                <v-btn
                    outlined
                    elevation="0"
                    @click="dowloadReport"
                    :disabled="loading"
                    style="margin-top: 1px; border-color: var(--v-ddgrey-base )">
                    <v-icon color="ddgrey">mdi-download</v-icon>
                </v-btn>
            </v-col>
            <v-col v-if="this.clinicLocations.length" cols="12" sm="auto">
                <LocationSelector
                    :loading="loading"
                    :locations="this.clinicLocations"
                    :initial="this.currentClinicLocation"
                    @selected="locationChanged"
                    @cleared="locationChanged(false)"/>
            </v-col>
            <v-col cols="12" sm="auto">
                <DateRangePicker
                    :loading="loading"
                    @selected="datesChanged"
                    @cleared="datesChanged(false)"/>
            </v-col>
        </v-row>

        <AIChatDataReport :clinic="this.clinic" :data="data" :dateFilter="this.dateFilter" :loading="loading" />
    </v-container>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import DataAPI from '@/utils/DataAPI';
import EventBus from '@/utils/EventBus';

import LocationSelector from '@/components/dashboard/controls/LocationSelector';
import DateRangePicker from '@/components/dashboard/controls/DateRangePicker';

import AIChatDataReport from '@/components/dashboard/aiChat/AIChatDataReport';


/**
 * This component includes all the features of Dashboard page such as change
 * between clinics, dates, download the report and show all other dashboard
 * widgets.
 *
 * To get data from the backend it uses the class DataAPI. To ensure that the
 * user is logged and check its capabilities it uses the class AuthAPI.
 */

export default {
    name: 'AIChatDashboard',
    props: {
      initialClinic: {
        type: String,
        default: ""
      },
      initialAccountId: {
        type: String,
        default: ""
      }
    },
    data: () => ({
        loading: true,
        rawData: {},
        clinic: "",
        clinicLocations: [],
        currentClinicLocation: 'all',
        data: {
            chats: {},
            existingVsNewOnes: {},
            stats: {},
            questions: {},
            locations: {
                locations: [],
                topLocations: []
            },
            devices: {},
            mostCommonlyQuestion: ''
        },
        dateFilter: {
            from: false,
            to: false
        },
        isMobile: false
    }),
    async mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize);
        await this.updateData(this.initialClinic, this.initialAccountId);
    },
    methods: {
        formatDateFilter() {
            const format = (date) => `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
            if (this.dateFilter.from && this.dateFilter.to && this.dateFilter.from !== this.dateFilter.to) {
                return `${format(this.dateFilter.from)} - ${format(this.dateFilter.to)}`;
            } else if (this.dateFilter.from) {
                return format(this.dateFilter.from);
            } else return 'all time';
        },
        async updateData(clinic = false, account = false, location = false) {
          console.log("Update data");
            // if (clinic) window.gtag('event', 'chat_selection_changed', { value: clinic });
            if (clinic && window.GA) window.GA.trackEvent('chat_selection_changed', clinic);

            this.loading = true;

            const { from, to } = this.dateFilter;
            console.log({ clinic, location, from, to })
            this.data = await DataAPI.getData({ clinic, account, location, from, to });
            this.clinic = this.data.clinic;
            if(this.data.clinicLocations && this.data.clinicLocations.length > this.clinicLocations.length) {
              this.clinicLocations = this.data.clinicLocations;
            }
            if(location) {
              this.currentClinicLocation = location;
            }
            this.loading = false;
        },
        async datesChanged(dates) {
            // if (dates && dates.length) window.gtag('event', 'date_filter_changed', { value: dates.join('  ~  ') });
            if (dates && dates.length && window.GA) window.GA.trackEvent('date_filter_changed', dates.join('  ~  '));
            let from, to;
            if (Array.isArray(dates)) {
                [ from, to ] = dates.length === 1 ? [ dates[0], dates[0] ] : dates;
            } else [ from, to ] = [ false, false ];
            this.dateFilter = { from, to };
            await this.updateData(this.clinic, this.initialAccountId);
        },
        async locationChanged(location) {
            // if (location) window.gtag('event', 'location_selectpr_changed', { value: location });
            if (location && window.GA) window.GA.trackEvent('location_selectpr_changed', location);

            await this.updateData(this.clinic, this.initialAccountId, location);
        },
        async dowloadReport() {
            EventBus.$emit("popup", "Downloading...");

            const reportElement = document.getElementById('report');
            const filename = `${ this.clinic } (${ this.formatDateFilter() }).pdf`;
            // window.gtag('event', 'report_download', { value: filename });
            if(window.GA)
              window.GA.trackEvent('report_download', filename);

            const canvas = await html2canvas(reportElement);
            const img = canvas.toDataURL('image/png');

            const doc = new jsPDF({
                unit: 'px',
                format: [ canvas.width, canvas.height ],
                hotfixes: ["px_scaling"]
            });

            doc.addImage(img, 'PNG', 0, 0);
            doc.save(filename);
        },
        onResize() {
            this.isMobile = window.innerWidth < 1000;
        }
    },
    components: {
        LocationSelector,
        DateRangePicker,
        AIChatDataReport
    }
}
</script>
